import React, { Component, Fragment, Suspense, lazy } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { LocalizeProvider } from "react-localize-redux";
import Auth from "./utils/auth";
import { initGA, logPageView } from "./utils/analytics";
import Home from "./containers/home";
import Premium from "./containers/premium";
import Error from "./containers/error";
import { Header, Footer, Loader } from "./components/index";
import ScrollToTop from "react-router-scroll-top";

/* Хуудас бүр өөрийн JS-ээ зөвхөн тэр хуудсанд орохдоо татна. Нүүр болон
   Premium (in-app browser-ийн автомат нэвтрэлтийн орох цэг) шууд ачаална —
   нэмэлт хүсэлтгүйгээр хамгийн хурдан зурагдана. */
const Account = lazy(() => import("./containers/account"));
const Success = lazy(() => import("./containers/success"));
const Failed = lazy(() => import("./containers/failed"));
const AcceptInvite = lazy(() => import("./containers/accept-invite"));
const ProfileEdit = lazy(() => import("./containers/profile-edit"));
const Faq = lazy(() => import("./containers/faq"));
const Tos = lazy(() => import("./containers/tos"));
const Contact = lazy(() => import("./containers/contact"));
const PremiumFamily = lazy(() => import("./containers/premium-family"));
const Login = lazy(() => import("./containers/login"));
const PaymentPage = lazy(() => import("./components/payment/payment"));
const MyMobi = lazy(() => import("./containers/my-mobi"));
const HeaderMyMobi = lazy(() => import("./components/Header/headerMyMobi"));
const MobiNewyear = lazy(() => import("./containers/mobi-newyear"));
const AppLink = lazy(() => import("./containers/app-link"));
const MongolMusic = lazy(() => import("./components/MongolMusic/mongolMusic"));
const ShowDeeplink = lazy(() => import("./containers/show"));
const PhoneAuth = lazy(() => import("./utils/email-auth"));

const routeFallback = (
  <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <Loader />
  </div>
);

const auth = new Auth();
auth.loadAuth();

class App extends Component {
  componentDidMount() {
    // Initialize Google Analytics
    initGA();

    // Track initial page view
    this.logPageView();

    // Track route changes
    this.unlisten = this.props.history?.listen(() => {
      this.logPageView();
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  logPageView = () => {
    const path = window.location.pathname + window.location.search;
    const title = document.title;
    logPageView(path, title);
  };

  render() {
    return (
      <LocalizeProvider>
        <Fragment>
          <Header auth={auth} />
          <main>
            <ScrollToTop>
              <Suspense fallback={routeFallback}>
                <Switch>
                  <Route
                    exact={true}
                    path="/sonsy/mymobi"
                    render={() => (
                      <Fragment>
                        <HeaderMyMobi />
                        <MyMobi />
                      </Fragment>
                    )}
                  />
                  <Route
                    exact={true}
                    path="/mobi/newyear"
                    render={() => (
                      <Fragment>
                        <MobiNewyear />
                      </Fragment>
                    )}
                  />
                  <Route
                    exact={true}
                    path="/contents/showlink"
                    render={() => (
                      <Fragment>
                        <ShowDeeplink />
                      </Fragment>
                    )}
                  />
                  <Route
                    exact={true}
                    path="/"
                    render={(props) => <Home {...props} />}
                  />
                  <Route
                    exact={true}
                    path="/premium"
                    render={(props) => <Premium auth={auth} {...props} />}
                  />
                  <Route
                    exact={true}
                    path="/invite"
                    render={() => <AcceptInvite auth={auth} />}
                  />
                  <Route
                    exact={true}
                    path="/profile"
                    render={() => <Account auth={auth} />}
                  />
                  <Route
                    exact={true}
                    path="/profile-edit"
                    render={() => <ProfileEdit auth={auth} />}
                  />
                  <Route
                    exact={true}
                    path="/success"
                    render={() => <Success auth={auth} />}
                  />
                  <Route exact={true} path="/failed" render={() => <Failed />} />
                  <Route exact={true} path="/help" render={() => <Faq />} />
                  <Route exact={true} path="/help/faq" render={() => <Faq />} />
                  <Route exact={true} path="/help/tos" render={() => <Tos />} />
                  <Route
                    exact={true}
                    path="/login"
                    render={(props) => <Login auth={auth} {...props} />}
                  />
                  <Route
                    exact={true}
                    path="/contact"
                    render={() => <Contact />}
                  />
                  <Route exact={true} path="/phoneauth" component={PhoneAuth} />
                  <Route
                    exact={true}
                    path="/mongolmusic"
                    component={MongolMusic}
                  />
                  <Route
                    exact={true}
                    path="/payment"
                    render={(props) => <PaymentPage auth={auth} {...props} />}
                  />
                  <Route
                    exact={true}
                    path="/premium/family"
                    render={(props) => <PremiumFamily auth={auth} {...props} />}
                  />
                  <Route exact={true} path="/app" render={() => <AppLink />} />
                  {/* Тасалбарын хуудсууд tickets.sonsy.mn руу шилжсэн.
                      Хуучин /event* хаягаар ирсэн хүсэлтийг сервер тал
                      301-ээр буулгадаг (`server/server.js`) тул энд
                      зам үлдээх шаардлагагүй. */}
                  <Route status={404} component={Error} />
                </Switch>
              </Suspense>
            </ScrollToTop>
          </main>
          <Footer />
        </Fragment>
      </LocalizeProvider>
    );
  }
}

export default withRouter(App);
